import { siteContent } from "../../content/siteContent";

export function Faq() {
  const { faq } = siteContent;

  return (
    <section id={faq.id} className="home-faq home-section" aria-labelledby="home-faq-title">
      <div className="home-shell home-faq__layout">
        <div className="home-faq__intro">
          <p className="home-eyebrow">{faq.eyebrow}</p>
          <h2 id="home-faq-title" className="home-editorial-heading">
            {faq.title}
          </h2>
          <p>{faq.intro}</p>
        </div>

        <div className="home-faq__items">
          {faq.items.map((item, index) => (
            <details key={item.question} className="home-faq__item" open={index === 0}>
              <summary>
                <span>{item.question}</span>
                <span className="home-faq__icon" aria-hidden="true" />
              </summary>
              <div className="home-faq__answer">
                <p>{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
